import { injectable } from "inversify"

import * as Api from "../constants/ApiUrlConstants"
import container from "../wires/Bootstrapper"
import SERVICE_IDENTIFIER from "../wires/Identifiers"

import { IApiService } from "./shared/ApiService"
import { IApiServiceExt } from "./shared/ApiServiceExt"

import { ModelBase } from "../models/ModelBase"
import { RuoloClienteInputModel, RuoloClienteViewModel, UtenteModel, UtenteViewModel } from "../models/UtenteModels"
import { SearcherBaseModel } from "../models/SearcherBaseModel"
import { ProjectionPagedModel } from "../models/ProjectionPageModel"

export interface IUtenteBackofficeService {
    Get(id: string): Promise<UtenteViewModel>
    Save(data: UtenteViewModel): Promise<ModelBase>
    Search(data: SearcherBaseModel): Promise<ProjectionPagedModel<UtenteModel>>
    RenderAssociaCliente(): Promise<RuoloClienteViewModel>
    AssociaCliente(data: RuoloClienteInputModel): Promise<ModelBase>
}

@injectable()
export class UtenteBackofficeService implements IUtenteBackofficeService {

    apiService: IApiService
    apiServiceExt: IApiServiceExt

    constructor() {
        this.apiService = container.get(SERVICE_IDENTIFIER.API_SERVICE)
        this.apiServiceExt = container.get(SERVICE_IDENTIFIER.API_SERVICE_EXT)
    }

    async Get(id: string): Promise<UtenteViewModel> {
        return await this.apiService.getAsync<UtenteViewModel>(Api.UtenteBackofficeGet, { id })
    }

    async Save(data: UtenteModel): Promise<ModelBase> {
        return await this.apiServiceExt.postAsync<ModelBase>(Api.UtenteBackofficeSave, data)
    }

    async Search(data: SearcherBaseModel): Promise<ProjectionPagedModel<UtenteModel>> {
        return await this.apiService.postAsync<ProjectionPagedModel<UtenteModel>>(Api.UtenteBackofficeSearch, data)
    }

    async RenderAssociaCliente(): Promise<RuoloClienteViewModel> {
        return await this.apiService.getAsync<RuoloClienteViewModel>(Api.UtenteBackofficeGetClientiAssociati, {})
    }

    async AssociaCliente(data: RuoloClienteInputModel): Promise<ModelBase> {
        return await this.apiServiceExt.postAsync<ModelBase>(Api.UtenteBackofficeAssociaCliente, data)
    }
}